import { createAction } from '@reduxjs/toolkit';

export const previewActionType = {
  UPDATE_FULL_PREVIEW: 'UPDATE_FULL_PREVIEW',
};

export const changeBomColor = createAction('changeBomColor');
export const changeLiteBomColor = createAction('changeLiteBomColor');
export const changePreview = createAction('changePreview');
export const changeLitePreview = createAction('changeLitePreview');
export const showPreviewPopup = createAction('showPreviewPopup');
export const hidePreviewPopup = createAction('hidePreviewPopup');
export const initMoreviews = createAction('initMoreviews');
export const initDefaultUrlIndex = createAction('initDefaultUrlIndex');
export const updateFullPreview = createAction(previewActionType.UPDATE_FULL_PREVIEW);
export const setPreviewDefaultImprintColorDict = createAction('ui/setPreviewDefaultImprintColorDict');
